export default __webpack_public_path__ + "d62d5f69ea7044acaa6c7bc6ff0b91a0.png";